export default "__VITE_ASSET__DdpXidTk__"